var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2185 2.42005C7.01457 2.21613 6.73799 2.10156 6.44959 2.10156C4.04738 2.10156 2.10001 4.04894 2.10001 6.45115V8.50285C2.10001 9.81599 2.4163 11.1098 3.02212 12.2748C4.9602 16.0019 7.99962 19.0414 11.7267 20.9795C12.8918 21.5853 14.1856 21.9016 15.4987 21.9016H18.4748C20.3665 21.9016 21.9 20.3681 21.9 18.4764C21.9 17.6175 21.4707 16.8154 20.7561 16.3389C20.3797 16.088 18.7917 15.0293 18.5887 14.979C18.3991 14.932 18.2009 14.932 18.0113 14.979C17.8083 15.0293 16.0766 16.2631 15.5332 16.5046C14.9897 16.746 14.3759 16.777 13.8109 16.5917C13.6166 16.528 12.4489 15.995 11.6612 15.4692C10.224 14.5098 9.47781 13.7868 8.53238 12.3403C8.10227 11.6823 7.65033 10.7188 7.59299 10.56C7.35883 9.91114 7.44577 8.94964 7.93242 8.30261C8.41906 7.65558 9.85519 6.34638 9.94422 6.07238C10.0225 5.83137 10.0225 5.57175 9.94422 5.33074C9.88142 5.13748 7.2185 2.42005 7.2185 2.42005Z",
    stroke: "#403D3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.41421,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.601b613ce97ef89c8aad2fa49d823473.svg";
export { ForwardRef as ReactComponent };